module.exports = __webpack_public_path__ + "media/images/tl/banner/ko-dark-16c6b55e51a4b69c9893de8961a902ec.jpg";